<template>
  <div>
    <v-toolbar card color="white">
      <v-toolbar-title>Lịch sử tin nhắn</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="pa-2">
        <div style="width: 234px" class="mr-2">
          <v-text-field
            solo
            hide-details
            prepend-inner-icon="search"
            placeholder="Tìm kiếm"
            v-model="keyword"
            @change="filterSMS()"
            @keyup.enter="filterSMS()"
          ></v-text-field>
        </div>
        <v-combobox solo class="mr-2" v-model="selectedStatus" :items="status" label="Status"></v-combobox>
        <v-menu
          v-model="menuFromDate"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
          class="mr-2"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="fromDate"
              prepend-inner-icon="event"
              readonly
              v-on="on"
              solo
              class="date-box"
            ></v-text-field>
          </template>
          <v-date-picker v-model="fromDate" @input="menuFromDate = false"></v-date-picker>
        </v-menu>
        <v-menu
          v-model="menuToDate"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
          class="mr-2"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="toDate"
              prepend-inner-icon="event"
              readonly
              v-on="on"
              solo
              class="date-box"
            ></v-text-field>
          </template>
          <v-date-picker v-model="toDate" @input="menuToDate = false"></v-date-picker>
        </v-menu>
      </v-toolbar-items>
    </v-toolbar>
    <v-divider></v-divider>
    <div class="scroll-area mx-4">
      <div class="scroll-container">
        <v-layout no-gutters class="sms" column>
          <v-flex v-for="(historySms, index) in sms" :key="index" cols="12">
            <v-card class="pb-1 my-1" tile>
              <v-card-text class="pt-1 pb-0">
                {{sms.length - index }}. {{ historySms.Message }}
              </v-card-text>
              <v-card-text class="py-0 d-flex justify-space-between">
                <v-card-title class="pa-0">
                  <span class="primary--text">{{ historySms.Email }}</span>
                  <span class="icon pl-1">
                    <v-icon>keyboard_arrow_right</v-icon>
                  </span>
                  <span class="phone pl-1">{{historySms.Phone}}</span>
                  <span class="pl-2">
                    <v-icon color="red" size="20" v-if="historySms.Status !== 0">info_circle</v-icon>
                    <v-icon color="green" size="20" v-else>check_circle</v-icon>
                  </span>
                </v-card-title>
                <v-card-title class="pa-0">
                  <span
                    class="time"
                  >{{ moment.unix(historySms.Time).utc().format('DD-MM-YYYY, HH:mm')}}</span>
                </v-card-title>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </div>
    </div>
    <v-card>
      <v-layout justify-space-around row wrap align-center class="mt-2">
        <v-flex sm9 md10>
          <v-form ref="form" class="px-4 pb-1" lazy-validation>
            <v-text-field
              :rules="phoneRule"
              v-model="phones"
              class="ma-0 pt-1"
              placeholder="Số điện thoại"
              required
              validate-on-blur
            ></v-text-field>
            <div class="layout row wrap align-center">
              <v-textarea
                no-resize
                :rules="mesRule"
                v-model="smsContent"
                class="ma-0 pt-1"
                placeholder="Nội dung tin nhắn"
                required
                validate-on-blurd
                rows="2"
              ></v-textarea>
              <p class="caption text-xs-right mb-2" :class="smsContent && smsContent.length > 160 ? 'orange--text text--darken-2' : ''">({{smsContent && smsContent.length || 0}} ký tự)</p>
            </div>
          </v-form>
        </v-flex>
        <v-flex sm3 md2>
          <v-container
            fluid
            class="d-flex justify-space-between py-2 px-4"
            style="flex-direction:column"
          >
            <v-menu top :offset-y="offset">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" v-on="on" large style="padding:0 60px">
                  SMS mẫu &nbsp;
                  <v-icon>textsms</v-icon>
                </v-btn>
              </template>
              <v-card class="mx-auto" max-width="344px" outlined tile>
                <div class="sms-menu">
                  <v-list max-width="334px" two-line>
                    <template v-for="(item,index) in patterns" :data-index="index">
                      <v-list-tile 
                        :key="index"
                        @click.stop="activePattern"
                        :data-index="index"
                        style="height:50px"
                      >
                        <v-list-tile-content :data-index="index">
                          <v-list-tile-title :data-index="index" v-text="item.Title"></v-list-tile-title>
                          <v-list-tile-sub-title :data-index="index" v-text="item.Content"></v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <v-menu top :offset-y="offset">
                            <template v-slot:activator="{ on }">
                              <v-btn icon>
                                <v-icon color="grey lighten-1" v-on="on">more_vert</v-icon>
                              </v-btn>
                            </template>
                            <v-list>
                              <v-list-tile :data-index="index">
                                <v-btn flat class="pa-0 ma-0" @click="edit" :data-index="index">
                                  Sửa
                                  <v-icon right :data-index="index">edit</v-icon>
                                </v-btn>
                              </v-list-tile>
                              <v-list-tile>
                                <v-btn
                                  flat
                                  class="pa-0 ma-0"
                                  @click="openDialogConfirmDelete(item)"
                                  color="red"
                                  :data-index="index"
                                >
                                  Xóa
                                  <v-icon right>delete</v-icon>
                                </v-btn>
                              </v-list-tile>
                            </v-list>
                          </v-menu>
                        </v-list-tile-action>
                      </v-list-tile>
                    </template>
                  </v-list>
                </div>
                <v-divider></v-divider>
                <v-card-actions class="justify-end align-center">
                  <v-dialog v-model="dialog" persistent max-width="600px" @click.native.stop>
                    <template v-slot:activator="{ on }">
                      <v-btn color="primary" v-on="on">Thêm mới</v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">Thêm tin nhắn mẫu</span>
                      </v-card-title>
                      <v-card-text>
                        <v-form ref="form1" lazy-validation>
                          <v-container>
                            <v-layout column>
                              <v-flex cols="12">
                                <v-text-field
                                  :rules="newTitleRule"
                                  v-model="newTitle"
                                  label="Tiêu đề"
                                  required
                                  validate-on-blur
                                ></v-text-field>
                              </v-flex>
                              <v-flex cols="12">
                                <v-textarea
                                  :rules="newContentRule"
                                  v-model="newContent"
                                  label="Nội dung"
                                  required
                                  validate-on-blur
                                ></v-textarea>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-form>
                      </v-card-text>
                      <v-card-actions class="justify-end">
                        <div class="flex-grow-1"></div>
                        <v-btn color="blue darken-1" dark text @click="addNewPattern">Lưu</v-btn>
                        <v-btn color="blue darken-1" flat dark text @click="dialog=false">Đóng</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-card-actions>
              </v-card>
            </v-menu>
            <v-btn
              class="ma-2"
              tile
              outlined
              color="success"
              @click="sendSms"
              large
              style="padding:0 60px"
            >
              Gửi
              <v-icon right>send</v-icon>
            </v-btn>
          </v-container>
        </v-flex>
      </v-layout>
    </v-card>
    <dialog-confirm ref="dialogConfirm" @confirm="handleConfirmDeleteMessage" :description="descriptionConfirm"/>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import moment from 'moment';
import { mapActions, mapMutations, mapGetters } from 'vuex';
import { isNumber } from 'util';
import validate from '@/utils/validate';
import DialogConfirm from '@/components/DialogConfirm';

export default {
  name: 'App',
  components: {
    VuePerfectScrollbar,
    DialogConfirm
  },
  data () {
    return {
      dialog: false,
      pattern: false,
      moment: moment,
      offset: true,
      closeOnContentClick: false,
      isEdit: -1,
      newTitle: '',
      newContent: '',
      phones: '',
      smsContent: '',
      phoneRule:
        [
          value => !!value || 'Số điện thoại không được để trống',
          value => (value && value.length >= 10) || 'Số điện thoại phải có ít nhất 10 kí tự',
          value => /^[0-9,]+$/.test(value) || 'Chỉ được nhập số và dấu phẩy'
        ],
      mesRule: [value => !!value || 'Nội dung tin nhắn không được để trống'],
      newTitleRule: [value => !!value || 'Tiêu đề không được để trống'],
      newContentRule: [value => !!value || 'Nội dung không được để trống'],
      sms: [
      ],
      patterns: [
      ],
      settings: {
        maxScrollbarLength: 60
      },
      fromDate: moment().add(-1, 'days').format('YYYY-MM-DD'),
      menuFromDate: false,
      toDate: moment().format('YYYY-MM-DD'),
      menuToDate: false,
      status: [
        'All',
        'Thành công',
        'Thất bại',
        'Đã gửi',
        'Đã nhận'
      ],
      selectedStatus: 'All',
      keyword: '',
      allSMS: [],
      dataDeletedMessage: null,
      descriptionConfirm: ''
    };
  },
  computed: {
    ...mapGetters(['loggedUser'])
  },
  watch: {
    fromDate () {
      this.filterSMS();
    },
    toDate () {
      this.filterSMS();
    },
    selectedStatus () {
      this.filterSMS();
    }
  },
  async mounted () {
    // const resSms = await this.GetHistoryMessages();
    // this.sms = await resSms;
    // this.allSMS = resSms;
    this.getHistorySms();
    const resAvailableSms = await this.GetAvailableMessage();
    this.patterns = resAvailableSms;
  },
  updated () {
    const container = document.querySelector('.scroll-container');
    container.scrollTop = 140 * this.sms.length;
    const menu = document.querySelector('.sms-menu');
    menu.scrollTop = 72 * this.patterns.length;
  },
  methods: {
    ...mapActions(['SendSMS', 'NewAvailableMessage', 'GetHistoryMessages', 'GetAvailableMessage', 'UpdateAvailableMessage', 'DeleteAvailableMessage']),
    async sendSms () {
      if (this.phones !== '' && this.smsContent !== '' && this.phones !== undefined && this.smsContent !== undefined && this.$refs.form.validate()) {
        const Content = this.smsContent;
        const phoneList = this.phones.split(',');
        const Email = this.loggedUser.Email;
        const data = {
          Phone: phoneList,
          Content: Content,
          Email
        };
        const res = await this.SendSMS(data);
        if (res) {
          // const resSms = await this.GetHistoryMessages();
          // this.sms = await resSms;
          // this.allSMS = resSms;
          await this.getHistorySms();
          this.$forceUpdate();
        }
        this.$refs.form.reset();
      } else {
        this.$refs.form.validate();
      }
    },
    async addNewPattern () {
      if (this.newTitle !== undefined && this.newContent !== undefined && this.newTitle !== '' && this.newContent !== '' && this.$refs.form1.validate()) {
        if (this.isEdit === -1) {
          const data = {
            Title: this.newTitle,
            Content: this.newContent
          };
          this.dialog = false;
          const res = await this.NewAvailableMessage(data);
          if (res) {
            const resAvailableSms = await this.GetAvailableMessage();
            this.patterns = resAvailableSms;
            this.$forceUpdate();
          }
        } else {
          this.dialog = false;
          const resUpdate = await this.UpdateAvailableMessage({
            Id: this.patterns[this.isEdit].Id,
            Title: this.newTitle,
            Content: this.newContent
          });
          this.isEdit = -1;
          if (resUpdate) {
            const resAvailableSms = await this.GetAvailableMessage();
            this.patterns = resAvailableSms;
            this.$forceUpdate();
          }
        }
      } else {
        this.$refs.form1.validate();
      }
    },
    async edit (event) {
      const className = event.target.className;
      if (className === 'v-btn__content') {
        const index = event.target.parentNode.dataset.index;
        this.isEdit = parseInt(index, 10);
      } else {
        const index = event.target.dataset.index;
        this.isEdit = parseInt(index, 10);
      }
      if (!isNaN(this.isEdit)) {
        this.dialog = true;
        this.newTitle = this.patterns[this.isEdit].Title;
        this.newContent = this.patterns[this.isEdit].Content;
      }
    },
    async del () {
      const res = await this.DeleteAvailableMessage({ Id: this.dataDeletedMessage.Id });
      if (res) {
        const resAvailableSms = await this.GetAvailableMessage();
        this.patterns = resAvailableSms;
        this.$forceUpdate();
      }
    },
    activePattern (event) {
      const activeItem = parseInt(event.target.dataset.index, 10);
      if (!isNaN(activeItem)) {
        this.smsContent = this.patterns[activeItem].Content;
      }
      // this.closeOnContentClick = true;
    },
    async filterSMS () {
      if (!this.allSMS.length) return;
      let start = moment(this.fromDate).hour(1);
      let end = moment(this.toDate).hour(23); 
      let array = [];
      array = this.allSMS.filter(item => (this.convertUnixTime(item.Time) >= start && this.convertUnixTime(item.Time) <= end));
      if (this.keyword) {
        array = array.filter(item => (item.Message + item.Email + item.Phone).toLowerCase().includes(this.keyword.toLowerCase()));
      }
      if (this.selectedStatus !== 'All') {
        if (this.selectedStatus === 'Thất bại') array = array.filter(item => item.Status !== 0);
        else if (this.selectedStatus === 'Thành công') array = array.filter(item => item.Status === 0);
        else if (this.selectedStatus === 'Đã nhận')array = array.filter(item => item.IsReceived);
        else array = array.filter(item => !item.IsReceived);
      }
      this.sms = array;
      console.log('this.sms', this.sms); 
    },
    async getHistorySms () {
      const resSms = await this.GetHistoryMessages();
      this.allSMS = resSms;
      this.filterSMS();
    },
    convertUnixTime (value) {
      return new Date(moment.unix(value).utc().format('YYYY-MM-DD, HH:mm'));
    },
    
    openDialogConfirmDelete (data) {
      this.dataDeletedMessage = data;
      this.descriptionConfirm = `Bạn chắc chắn muốn xóa tin nhắn mẫu ${data.Title}?`;
      this.$refs.dialogConfirm.open();
    },

    handleConfirmDeleteMessage () {
      this.del();
    }
  }
};
</script>
<style scope lang="scss">
* {
  box-sizing: border-box;
}
.scroll-area {
  position: relative;
  // width: 95vw;
  margin: 0 auto;
  height: calc(100vh - 275px);
  overflow: hidden;
}
.scroll-container{
  height: 100%;
  overflow-y: auto;
}
/*Width*/
.scroll-container::-webkit-scrollbar {
  width: 10px;
}
/* Track */
.scroll-container::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
/* Handle */
.scroll-container::-webkit-scrollbar-thumb {
  background: #888; 
  border-radius: 4px;
}
/* Handle on hover */
.scroll-container::-webkit-scrollbar-thumb:hover {
  background: #555; 
}
.sms-menu {
  margin: auto;
}
.v-menu__content.theme--light.menuable__content__active {
  overflow: hidden !important;
}
.d-flex > *,
.d-inline-flex > * {
  flex: 0 0 auto !important;
}

</style>



// WEBPACK FOOTER //
// src/pages/sendsms/Index.vue